import moment from 'moment'

export function formatDate(date: string, pattern: string) {
  return moment(date).utc(true).format(pattern)
}
